module.exports = __webpack_public_path__ + "img/temperature-list.740b15f1.svg";